/**
 * Terminus NavPlatformSwitcher Component v1.0.0
 */
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { SvgComponent } from '@terminus-ui/svg';

const demandscienceLogoWhite = require('../../../images/demandscience-logo-white.svg');

@Component({
  selector: 'tux-nav-platform-switcher',
  templateUrl: './nav-platform-switcher.component.html',
  styleUrls: ['./nav-platform-switcher.component.scss'],
  imports: [CommonModule, FontAwesomeModule, SvgComponent],
})
export class NavPlatformSwitcherComponent {
  @Input() appName: string;
  demandscienceLogoWhite = demandscienceLogoWhite;
  faCaretDown = faCaretDown;
}
